<div class="col-12">
    <label class="form-label">
        {{ label }}
        @if (required) { <span class="text-danger">*</span> }
    </label>
    <dx-select-box
        [value]="value"
        (onValueChanged)="onValueChanged($event)"
        [dataSource]="dataSource"
        valueExpr="id"
        displayExpr="name"
        stylingMode="filled"
        [placeholder]="'Select ' + label"
        [searchEnabled]="true"
    >
        @if (required) {
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        }
    </dx-select-box>
</div>

